import React from "react";
import axios from "axios";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faSearch,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../../masters/master.css";
import Select from "react-select";
import { Redirect, withRouter, Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { Modal, Button } from "react-bootstrap";
// import { PdfReader } from "../../utils/DocumentViewer";
import { ViewLeasePdfReader } from "../../utils/ViewLeaseDocumentViewer";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";

import { ReactMultiEmail } from "react-multi-email";
import * as Yup from "yup";
import { Loader } from "rsuite";

const selectStyles = {
  border: "0",
  background: "#ddd",
};
const Schema = Yup.object({
  alertName: Yup.string().required("This field is required"),
  alertText: Yup.string().required("This field is required"),
  reportId: Yup.string().required("This field is required"),
  stateName: Yup.string().required("This field is required"),
  brandSelected: Yup.array().required("Provide at least one tag"),
  frequencySelected: Yup.array().required("Provide at least one tag"),
});

const prospectFilterForm = Yup.object().shape({
  //assetType: Yup.string().required("Required"),
  //city: Yup.string().required("Required"),
  //brandCategory: Yup.string().required("Required"),
  assetName: Yup.string().required("Required"),
  floor: Yup.string().required("Required"),
  //rangeFrom: Yup.string().required("Required"),
  //rangeTo: Yup.string().required("Required"),
});

const prospectValidation = Yup.object().shape({
  landlordAssetId: Yup.string().required("Required"),
  //gla: Yup.string().required("Required"),
});

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

const prospectObj = {
  project_id: "",
  "19_36_months": "",
  address: "",
  agreement_type: "",
  automated_daily_sales_report_adsr: "",
  brand_name: "",
  cam_charges: "",
  cam_commencement_date: "",
  cam_escalation: "",
  cancellation_and_termination: "",
  carpet_area: "",
  confidentiality: "",
  delay_in_commencement_licensee: "",
  delay_in_scheduled_date_proposed_licensee: "",
  eligibility_under_laws: "",
  escalation_on_monthly_lease_rental: "",
  extension_of_term_renewal_term: "",
  first_month_18th_month: "",
  franchisee_by_party2: "",
  governing_law_and_jurisdiction: "",
  gst_and_other_taxes_surcharges_levies_etc: "",
  handover_date: "",
  ifrm_sd_amount: "",
  ifrm_sd_cam_deposit_escalation: "",
  ifrm_sd_cam_deposit_for_company_name: "",
  ifrm_sd_instalment_1: "",
  ifrm_sd_instalment_2: "",
  ifrm_sd_instalment_3: "",
  ifrm_sd_months: "",
  ifrm_sd_payment_schedule: "",
  ifrm_sd_rate: "",
  ifrsd_amount: "",
  ifrsd_months: "",
  ifrsd_payment_schedule: "",
  ifrsd_rate: "",
  ifrsd_rent_deposit_escalation: "",
  ifrsd_rent_deposit_for_company_name: "",
  industry_of_party2: "",
  instalment_1: "",
  instalment_2: "",
  instalment_3: "",
  insurance: "",
  lease_commencement_date: "",
  lessee: "",
  lessor: "",
  lock_in_period_for_party_2: "",
  loi_issue_date: "",
  monthly_fixed_rental_or_revenue_share: "",
  monthly_lease_rental_logic_basis: "",
  monthly_lease_rental_rent_commencement_date: "",
  monthly_variable_rental_revenue_share: "",
  nature_of_party2: "",
  other_charges_for_the_permitted_business: "",
  parking: "",
  party_2_details: "",
  party_2_kyc_details: "",
  payment_mechanism_charges: "",
  pre_fit_out_handover_requirements: "",
  property_tax: "",
  rent_free_fit_out_period_from_handover_date: "",
  representations_and_warranties: "",
  signage: "",
  stamp_duty_and_registration_charges: "",
  super_area: "",
  term: "",
  to_be_completed_by_party1: "",
  to_be_completed_by_party2: "",
  unit_details: "",
  utilities: "",
  utility_charges_commencement_date: "",
  validity_of_loi: "",
  status: 1,
};

class Prospect extends React.Component {
  mainFormValidator = [];

  state = {
    redirect: false,
    id: undefined,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    prospectFields: [],
    url: `${apiUrl.apiUrl.url}/prospect/create`,
    assetNames: [],
    allData: [],
    isProcessing: false,
    initialValues: {},
    prospectInitialValues: prospectObj,
    taintedFields: [],
    showMailLoader: false
  };

  constructor(props) {
    super(props);
    this.buttonRef = React.createRef();
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }
  componentDidMount() {
    this.fetchProspectFields();
    // Simulate a click event when the component mounts
    if (this.buttonRef.current) {
      //this.buttonRef.current.click();
    }
  }

  componentDidUpdate() {
    var self = this;
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;

      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/prospect/create`,
          prospectInitialValues: prospectObj,
        });
      } else {
        this.fetchProspect(this.props.match.params.id);
      }
    }
  }

  setColorLogicForFields() {
    var taintedFields = [];
    this.setState({ taintedFields: taintedFields });
    if (this.state.allData.length > 1) {
      this.state.allData.map((values, dataIndex) => {
        var taintedFieldsObj = {};
        if (dataIndex != 0) {
          for (const key in values) {
            if (values[key] != this.state.allData[dataIndex - 1][key]) {
              taintedFieldsObj[key] = true;
            } else {
              taintedFieldsObj[key] = false;
            }
            for (const key2 in values["additional_info"]) {
              console.log(key2, "ley");
              for (const key3 in values["additional_info"][key2]) {
                if (
                  typeof this.state.allData[dataIndex - 1]["additional_info"][
                  key2
                  ] == "undefined" ||
                  typeof this.state.allData[dataIndex - 1]["additional_info"][
                  key2
                  ][key3] == "undefined"
                ) {
                  taintedFieldsObj[key3] = true;
                } else if (
                  values["additional_info"][key2][key3] !=
                  this.state.allData[dataIndex - 1]["additional_info"][key2][
                  key3
                  ]
                ) {
                  taintedFieldsObj[key3] = true;
                } else {
                  taintedFieldsObj[key3] = false;
                }
              }
            }
          }
          taintedFields[dataIndex] = taintedFieldsObj;
        } else {
          for (const key in values) {
            taintedFieldsObj[key] = false;
          }
          taintedFields[dataIndex] = taintedFieldsObj;
        }
      });
      this.setState({ taintedFields: taintedFields });
    }
  }

  fetchProspect(id) {
    let self = this;
    axios.get(`${apiUrl.apiUrl.url}/prospect/fetch-prospect-data?id=${this.props.match.params.id}`).then((response) => {
      let data = response.data;
      self.setState({
        url: `${apiUrl.apiUrl.url}/prospect/update?id=${self.props.match.params.id}`,
        prospectInitialValues: data["current"],
        allData: data["all"],
      });
      self.setState({});
      self.setColorLogicForFields();
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/prospect/fetch-prospect-data?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     console.log(data);
    //     self.setState({
    //       url: `${apiUrl.apiUrl.url}/prospect/update?id=${self.props.match.params.id}`,
    //       prospectInitialValues: data["current"],
    //       allData: data["all"],
    //     });
    //     self.setState({});
    //     self.setColorLogicForFields();
    //     console.log("done");
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  fetchProspectFields() {
    fetch(`${apiUrl.apiUrl.url}/prospect/fetch-prospect-fields`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          prospectFields: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  cloneProspect() {
    if (
      typeof this.props.match.params.id != "undefined" &&
      this.state.isProcessing == false
    ) {
      this.setState({ isProcessing: true });
      let self = this;
      axios({
        method: "post",
        url: `${apiUrl.apiUrl.url}/prospect/clone`,
        data: { id: this.props.match.params.id },
      }).then(function (response) {
        if (!response.data.success) {
          self.setState({
            popupalertMessage: true,
            popupMessageContent: response.data.msg || "Something went wrong",
          });
        } else {
          self.setState({
            messsagePopup: true,
            popupContent: "Prospect Cloned",
          });
        }
        self.setState({ isProcessing: false, newid: response.data.id });
      });
    }
  }

  downloadProspect() {
    if (
      typeof this.props.match.params.id != "undefined" &&
      this.state.isProcessing == false
    ) {
      this.setState({ isProcessing: true });
      let self = this;
      axios({
        method: "post",
        url: `${apiUrl.apiUrl.url}/prospect/download`,
        data: { id: this.props.match.params.id },
      }).then(function (response) {
        console.log(response, "response")
        if (!response.data.success) {
          self.setState({
            popupalertMessage: true,
            popupMessageContent: response.data.msg || "Something went wrong",
          });
        } else {
          window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response.data.filename}`;
        }
        self.setState({ isProcessing: false });
      });
    }
  }

  closeProspect() {
    if (
      typeof this.props.match.params.id != "undefined" &&
      this.state.isProcessing == false
    ) {
      this.setState({ isProcessing: true });
      let self = this;
      axios({
        method: "post",
        url: `${apiUrl.apiUrl.url}/prospect/close`,
        data: { id: this.props.match.params.id },
      }).then(function (response) {
        if (!response.data.success) {
          self.setState({
            popupalertMessage: true,
            popupMessageContent: response.data.msg || "Something went wrong",
          });
        } else {
          self.setState({
            messsagePopup: true,
            popupContent: "Prospect Finalised",
          });
          self.fetchProspect(self.props.match.params.id);
        }
        self.setState({ isProcessing: false });
      });
    }
  }

  sendProspect() {
    this.setState({ isModalOpen: true });
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false }, () => {
      if (typeof this.state.newid != "undefined") {
        this.props.history.push("/createlease/prospect/" + this.state.newid);
      }
    });
  };

  redirectToClose = () => {
    this.setState({
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  resetForm(values) {
    this.state.initialValues = {};
    values.stateId = "";
    values.emails = "";
    this.state.initialValues.alertText = "";
    this.state.showMailLoader = false;
    this.setState({});
  }

  valueChange = (newValue, actionMeta) => {
    this.state.initialValues.alertText = newValue.target.value;
    this.setState({});
  };

    toCamelCase = (str) => {
      return str.toLowerCase();
      return str
          .split(/[^a-zA-Z0-9]+/) // Split on non-alphanumeric characters
          .map((word, index) => {
              if (index === 0) {
                  return word.toLowerCase(); // Keep the first word in lowercase
              }
              return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); // Capitalize the first letter
          })
          .join(''); // Join the words back together
  }

  submitForm = (values) => {
    console.log(this.validator.allValid());
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      return false;
    }

    console.log(values, "asdas", this.state);

    var self = this;
    this.state.initialValues.id = this.props.match.params.id;
    if (
      typeof this.props.match.params.id != "undefined" &&
      this.state.isProcessing == false
    ) {
      this.setState({ showMailLoader: true });
      axios({
        method: "post",
        url: `${apiUrl.apiUrl.url}/prospect/send`,
        data: this.state.initialValues,
      }).then(function (response) {
        if (!response.data.success) {
          self.setState({
            popupalertMessage: true,
            popupMessageContent: response.data.msg || "Something went wrong",
          });
        } else {
          self.setState({ isModalOpen: false });
          self.setState({
            messsagePopup: true,
            popupContent: "Prospect sent",
          });
        }
        self.setState({ isProcessing: false, showMailLoader: false });
        self.resetForm(values);
      });
    }
  };

  render() {
    return (
      <div
        className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  

  openModal = () => this.setState({ isModalOpen: true });
  closeModal = () => this.setState({ isModalOpen: false });
  renderForm() {
    return (
      <div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
        <Formik>
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
            setFieldValue,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off" >
                <div className="container-fluid">
                  <div className="row">
                    <div className="tableContainer prospectTable prospectTableView">
                      <table className="table tableSimple tableSimpleWithNoFlex">
                        <thead>
                          <tr>
                            <th scope="col">Field Name</th>
                            {this.state.allData.map((values, dataIndex) => (
                              <>
                                <th scope="col">Prospect {dataIndex + 1}</th>
                                <th scope="col">Notes {dataIndex + 1}</th>
                              </>
                            ))}

                              {/* {this.state.allData.map((values, dataIndex) => (
                                <th scope="col">Notes {dataIndex + 1}</th>
                            ))} */}

                            {/* <th scope="col">Prospect</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <h6>Prospect Code</h6>
                            </td>
                            {this.state.allData.map((values, dataIndex) => (
                              <>
                                <td
                                  className={
                                    this.state.taintedFields.length > 0 &&
                                      this.state.taintedFields[dataIndex][
                                      "prospect_code"
                                      ]
                                      ? "cloneTrTdclass"
                                      : ""
                                  }
                                >
                                  {values["prospect_code"]}
                                </td>
                                <td>&nbsp;</td>
                              </>
                            ))}
                          </tr>
                          <tr>
                            <td>
                              <h6>Unit(s), Floor & Location</h6>
                            </td>
                            {this.state.allData.map((values, dataIndex) => (
                              <>
                                <td
                                  className={
                                    this.state.taintedFields.length > 0 &&
                                      this.state.taintedFields[dataIndex][
                                      "unit_details"
                                      ]
                                      ? "cloneTrTdclass"
                                      : ""
                                  }
                                >
                                  {values["unit_details"]}
                                </td>
                                <td>&nbsp;</td>
                              </>
                            ))}
                            
                          </tr>
                          <tr>
                            <td>
                              <h6>Carpet Area of Unit</h6>
                            </td>
                            {/* <td> */}
                            {/* {this.state.prospectInitialValues['carpet_area']} */}
                            {this.state.allData.map((values, dataIndex) => (
                              <>
                              <td
                                className={
                                  this.state.taintedFields.length > 0 &&
                                    this.state.taintedFields[dataIndex][
                                    "carpet_area"
                                    ]
                                    ? "cloneTrTdclass"
                                    : ""
                                }
                              >
                                {values["carpet_area"]}
                              </td>

                              <td className={ this.state.taintedFields.length > 0 && this.state.taintedFields[dataIndex]["carpet_area"]?"cloneTrTdclass": ""} >
                                {
                                  values['additional_notes'] &&
                                  values['additional_notes']['main'] &&
                                  values['additional_notes']['main']["carpet_area"]
                                    ? values['additional_notes']['main']["carpet_area"]
                                    : ''
                                }

                              </td>
                              
                              </>
                              
                            ))}
                            {/* </td> */}
                          </tr>
                          <tr>
                            <td>
                              <h6>
                                Super Area (chargeable Area)* Of The Unit(s)
                              </h6>
                            </td>
                            {this.state.allData.map((values, dataIndex) => (
                              <>
                              <td
                                className={
                                  this.state.taintedFields.length > 0 &&
                                    this.state.taintedFields[dataIndex][
                                    "super_area"
                                    ]
                                    ? "cloneTrTdclass"
                                    : ""
                                }
                              >
                                {values["super_area"]}
                              </td>
                              <td
                              className={
                                this.state.taintedFields.length > 0 &&
                                  this.state.taintedFields[dataIndex][
                                  "super_area"
                                  ]
                                  ? "cloneTrTdclass"
                                  : ""
                              }
                            >
                              {
                                values['additional_notes'] &&
                                values['additional_notes']['main'] &&
                                values['additional_notes']['main']["super_area"]
                                  ? values['additional_notes']['main']["super_area"]
                                  : ''
                              }

                            </td>
                            </>
                            ))}
                          </tr>

                          <tr>
                            <td>
                              <h6>Name Of The Project</h6>
                            </td>
                            {this.state.allData.map((values, dataIndex) => (
                              <>
                                <td
                                  className={
                                    this.state.taintedFields.length > 0 &&
                                      this.state.taintedFields[dataIndex][
                                      "assetName"
                                      ]
                                      ? "cloneTrTdclass"
                                      : ""
                                  }
                                >
                                  {values["assetName"]}
                                </td>
                                <td>&nbsp;</td>
                              </>
                            ))}
                            
                          </tr>
                          <tr>
                            <td>
                              <h6>Address Of The Project</h6>
                            </td>
                            {this.state.allData.map((values, dataIndex) => (
                              <>
                              <td
                                className={
                                  this.state.taintedFields.length > 0 &&
                                    this.state.taintedFields[dataIndex]["address"]
                                    ? "cloneTrTdclass"
                                    : ""
                                }
                              >
                                {values["address"]}
                              </td>
                              <td
                              className={
                                this.state.taintedFields.length > 0 &&
                                  this.state.taintedFields[dataIndex][
                                  "address"
                                  ]
                                  ? "cloneTrTdclass"
                                  : ""
                              }
                            >
                              {
                                values['additional_notes'] &&
                                values['additional_notes']['main'] &&
                                values['additional_notes']['main']["address"]
                                  ? values['additional_notes']['main']["address"]
                                  : ''
                              }

                            </td>
                            </>
                            ))}
                          </tr>
                          <tr>
                            <td>
                              <h6>Broking By</h6>
                            </td>
                            {this.state.allData.map((values, dataIndex) => (
                              <>
                              <td
                                className={
                                  this.state.taintedFields.length > 0 &&
                                    this.state.taintedFields[dataIndex]["broking_by"]
                                    ? "cloneTrTdclass"
                                    : ""
                                }
                              >
                                {values["broking_by"]}
                              </td>
                              <td
                                className={
                                  this.state.taintedFields.length > 0 &&
                                    this.state.taintedFields[dataIndex][
                                    "broking_by"
                                    ]
                                    ? "cloneTrTdclass"
                                    : ""
                                }
                              >
                                {
                                  values['additional_notes'] &&
                                  values['additional_notes']['main'] &&
                                  values['additional_notes']['main']["broking_by"]
                                    ? values['additional_notes']['main']["broking_by"]
                                    : ''
                                }
                            </td>
                            </>
                            ))}
                          </tr>
                          <tr>
                            <td>
                              <h6>Broker Name</h6>
                            </td>
                            {this.state.allData.map((values, dataIndex) => (
                              <>
                              <td
                                className={
                                  this.state.taintedFields.length > 0 &&
                                    this.state.taintedFields[dataIndex]["broker_name"]
                                    ? "cloneTrTdclass"
                                    : ""
                                }
                              >
                                {values["broker_name"]}
                              </td>
                              <td
                              className={
                                this.state.taintedFields.length > 0 &&
                                  this.state.taintedFields[dataIndex][
                                  "broker_name"
                                  ]
                                  ? "cloneTrTdclass"
                                  : ""
                              }
                            >
                              
                              {
                                values['additional_notes'] &&
                                values['additional_notes']['main'] &&
                                values['additional_notes']['main']["broker_name"]
                                  ? values['additional_notes']['main']["broker_name"]
                                  : ''
                              }
                            </td>
                            </>
                            ))}
                          </tr>
                          <tr>
                            <td>
                              <h6>Broking Type</h6>
                            </td>
                            {this.state.allData.map((values, dataIndex) => (
                              <>
                              <td
                                className={
                                  this.state.taintedFields.length > 0 &&
                                    this.state.taintedFields[dataIndex]["broking_type"]
                                    ? "cloneTrTdclass"
                                    : ""
                                }
                              >
                                {values["broking_type"]}
                              </td>
                              <td
                              className={
                                this.state.taintedFields.length > 0 &&
                                  this.state.taintedFields[dataIndex][
                                  "broking_type"
                                  ]
                                  ? "cloneTrTdclass"
                                  : ""
                              }
                            >
                              {
                                values['additional_notes'] &&
                                values['additional_notes']['main'] &&
                                values['additional_notes']['main']["broking_type"]
                                  ? values['additional_notes']['main']["broking_type"]
                                  : ''
                              }
                            </td>
                            </>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <Accordion defaultActiveKey="0">
                  {this.state.prospectFields.map((section, index) => (
                    //console.log(section),
                    <div key={index} className="container-fluid">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>{section.title}</Accordion.Header>
                            <Accordion.Body>
                              <div className="tableContainer prospectTableView tableFixedLayout mt-0">
                                <table className="table tableSimple tableSimpleWithNoFlex">
                                  {section.form_fields.map(
                                    (topSection, topIndex) => (
                                      //console.log(topSection),
                                      <>
                                        {topSection.sub_title && (
                                          <thead>
                                            <tr>
                                              <th
                                                scope="col"
                                                colSpan={
                                                  this.state.allData.length*
                                                  2+1
                                                }
                                              >
                                                {topSection.sub_title}
                                              </th>
                                            </tr>
                                          </thead>
                                        )}
                                        {topSection.fields.map((field, i) => (
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h6 style={{ textTransform: "capitalize" }} >{field.title.toLowerCase()}</h6>
                                              </td>
                                              {this.state.allData.map(
                                                (values, dataIndex) => (
                                                  // className={  dataIndex != 0 && typeof this.state.taintedFields[dataIndex][field.name] != "undefined" && this.state.taintedFields[dataIndex][field.name] ? 'cloneTrTdclass' : '' }
                                                  <>
                                                  <td
                                                    className={
                                                      this.state.taintedFields.length > 0 &&
                                                      this.state.taintedFields[dataIndex] &&
                                                      this.state.taintedFields[dataIndex][field.name]
                                                        ? "cloneTrTdclass"
                                                        : ""
                                                    }
                                                  >
                                                    {
                                                      values["additional_info"] &&
                                                      values["additional_info"][field.section] &&
                                                      values["additional_info"][field.section][field.title]
                                                        ? values["additional_info"][field.section][field.title]
                                                        : ""
                                                    }

                                                    {
                                                      typeof field.additional_info === "undefined" && values[field.name]
                                                        ? values[field.name]
                                                        : ""
                                                    }
                                                  </td>
                                                  <td>
                                                  {
                                                    field.additional_info === true 
                                                      ? (values['additional_notes'][field.section] &&
                                                        values['additional_notes'][field.section][field.name]
                                                          ? values['additional_notes'][field.section][field.name]
                                                          : '')
                                                      : (values['additional_notes']['main'] &&
                                                        values['additional_notes']['main'][field.name]
                                                          ? values['additional_notes']['main'][field.name]
                                                          : '')
                                                  }
                                                  </td>
                                                  </>
                                                )
                                              )}
                                            </tr>
                                          </tbody>
                                        ))}
                                      </>
                                    )
                                  )}

                                  <tbody></tbody>
                                </table>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  ))}
                </Accordion>
                <div className="button_group formSubmit my-3 me-3 d-flex align-items-center gap-3 justify-content-end">
                  {this.state.prospectInitialValues.status == 0 && (
                    <>
                      <button
                        className="add_button"
                        type="button"
                        ref={this.buttonRef}
                        onClick={(e) => {
                          this.cloneProspect();
                        }}
                      >
                        Clone Prospect
                      </button>
                      <button
                        className="update_button"
                        type="button"
                        ref={this.buttonRef}
                        onClick={(e) => {
                          this.closeProspect();
                        }}
                      >
                        Finalise Prospect
                      </button>
                    </>
                  )}
                  <button
                    className="add_button"
                    type="button"
                    ref={this.buttonRef}
                    onClick={(e) => {
                      this.sendProspect();
                    }}
                  >
                    Send Proposal
                  </button>
                  <button
                    className="reset_button"
                    type="button"
                    ref={this.buttonRef}
                    onClick={(e) => {
                      this.downloadProspect();
                    }}
                  >
                    Download
                  </button>
                </div>

              </Form>
            </div>
          )}
        </Formik>
        <Modal
          show={this.state.isModalOpen}
          onHide={this.closeModal}
          size="xl"
          className="documentModal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <div className="container modalBreadCrumbs">
                <div className="row">
                  <div className="col-lg-12">
                    <ul>
                      <li>Send Mail</li>
                    </ul>
                  </div>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ backgroundColor: "#fff" }}>
            <Formik
              validationSchema={Schema}
              initialValues={this.state.initialValues}
              enableReinitialize
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
              }) => (
                <div className="unitFormContainerNew">

                  <form autoComplete="off" onSubmit={handleSubmit}>
                    <div className="newGridSectionParent">
                      <div className="newGridSectionForFormMain">
                        <div className="gridColOneByThree">
                          <div className="newGridSectionInner">
                            <label>Email</label>
                            <div className="position-relative">
                              <ReactMultiEmail
                                className="alertEmailClass"
                                emails={this.state.initialValues.emails}
                                onKeyPress={(e) => { }}
                                onChange={(_emails: string[]) => {
                                  this.state.initialValues.emails = _emails;
                                  this.setState({});
                                }}
                                getLabel={(
                                  email: string,
                                  index: number,
                                  removeEmail: (index: number) => void
                                ) => {
                                  return (
                                    <div data-tag key={index}>
                                      {email}
                                      <span data-tag-handle onClick={() => removeEmail(index)}>
                                        x
                                      </span>
                                    </div>
                                  );
                                }}
                              />
                              {this.validator.message(
                                "Email",
                                this.state.initialValues.emails,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="gridColOneByThree">
                          <div className="newGridSectionInner">
                            <label>Mail Text</label>
                            <div className="position-relative">
                              <textarea
                                name="alertText"
                                onChange={(e) => {
                                  this.valueChange(e, "change_alert_text");
                                }}
                                style={{height: "100px"}}
                                value={this.state.initialValues.alertText}
                              ></textarea>
                              {this.validator.message(
                                "Body",
                                this.state.initialValues.alertText,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className="button_group d-flex justify-content-end gap-3 mt-4">
                        <button className="add_button" type="button" onClick={this.submitForm}>
                          Send
                        </button>
                        <button
                          className="cancel_button"
                          type="reset"
                          onClick={(e) => {
                            this.resetForm(values);
                            this.closeModal();
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </Formik>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.closeModal}
              >
                Close
              </Button>
            </Modal.Footer> */}
        </Modal>
      </div>
    );
  }
}

export default withRouter(Prospect);
